import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getWorkflowsQueryKey } from "../lib/workflowsQuery"

type Variables = { workflowId: string; name?: string | null; campaignId?: string }

// `scopeCampaignId` is the canvas currently being viewed; `campaignId` (per-call) is the copy's
// target. They can differ when duplicating into another campaign, so both scopes are refreshed.
export function useDuplicateWorkflowMutation(scopeCampaignId?: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ workflowId, name, campaignId }: Variables) => {
      const response = await axios.post(`/workflows/${workflowId}/duplicate`, { name, campaignId })
      return response.data.data
    },
    onSuccess: (_data, { campaignId }) => {
      queryClient.invalidateQueries({ queryKey: getWorkflowsQueryKey(scopeCampaignId) })
      queryClient.invalidateQueries({ queryKey: getWorkflowsQueryKey(campaignId) })
    },
  })
}
